module.exports = __webpack_public_path__ + "img/saum_opalgruen_ral6026.a3f2147c.jpg";